export const getRandomEl = <T>(arr: Array<T>): T => {
  const idx = Math.floor(Math.random() * arr.length)
  /* eslint-disable-next-line  @typescript-eslint/no-non-null-assertion */
  return arr[idx]!
}
